import { motion } from "framer-motion";
import { Globe, Rocket, Zap } from "lucide-react";

const EASE = [0.33, 1, 0.68, 1];

const POINTS = [
  {
    id: "global",
    num: "01",
    icon: Globe,
    title: "Born Global",
    body: "Designed from day one to operate without borders, scaling technical, energy, and physical solutions to international markets.",
  },
  {
    id: "synergy",
    num: "02",
    icon: Zap,
    title: "Cross-Sector Synergy",
    body: "We use our own software architectures and clean energy designs to directly power our manufacturing hubs, real estate, and farming projects.",
  },
  {
    id: "assets",
    num: "03",
    icon: Rocket,
    title: "Future-Proof Assets",
    body: "Every pipeline we launch is heavily optimized for long-term sustainability, systemic efficiency, and generational value.",
  },
];

const Edge = () => {
  return (
    <section
      id="insights"
      data-testid="edge-section"
      className="relative border-t border-white/10 bg-surface py-32 md:py-44"
    >
      <div className="mx-auto max-w-[1600px] px-6 md:px-12">
        <motion.p
          initial={{ opacity: 0, x: -24 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, ease: EASE }}
          className="font-mono text-xs uppercase tracking-[0.35em] text-neon md:text-sm"
          data-testid="edge-overline"
        >
          // WHY WE BUILD
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, delay: 0.1, ease: EASE }}
          className="mt-6 max-w-3xl font-display text-3xl font-medium tracking-tight sm:text-4xl md:text-5xl"
          data-testid="edge-headline"
        >
          The Future Factory Edge
        </motion.h2>

        <div className="mt-20 grid grid-cols-1 border border-white/10 md:grid-cols-3">
          {POINTS.map((point, i) => {
            const Icon = point.icon;
            return (
              <motion.div
                key={point.id}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.85, delay: i * 0.14, ease: EASE }}
                className="group relative border-white/10 p-10 transition-colors duration-500 hover:bg-white/[0.03] md:border-l md:p-12 md:first:border-l-0"
                data-testid={`edge-point-${point.id}`}
              >
                <div className="flex items-center justify-between">
                  <Icon
                    className="h-7 w-7 text-cyber transition-transform duration-500 group-hover:-translate-y-1"
                    strokeWidth={1.25}
                  />
                  <span className="font-mono text-xs tracking-[0.3em] text-white/25">{point.num}</span>
                </div>
                <h3 className="mt-16 font-display text-xl font-medium tracking-tight md:text-2xl">
                  {point.title}
                </h3>
                <p className="mt-5 text-sm leading-relaxed text-secondary">{point.body}</p>
                <span className="mt-10 block h-px w-full origin-left scale-x-0 bg-neon transition-transform duration-700 group-hover:scale-x-100" />
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Edge;
